module.exports = __webpack_public_path__ + "static/img/left_icon.be1d4ca1.svg";